
export class LignePanier {
  
  id: number;
  idOffreCommerciale: number;
  quantite: number;
  indicateurAdoption: boolean;
  prixUnitaireTTC: number;
  montantTotal: number;
  controlePreuvesAchat: boolean;
  referenceLPC: string;
  typeLicence: string;
  dureeLicence: string;
  tauxDeTaxe: number;
  tauxRemise: number;
  quantiteLivraisonSupplementaire: number;
  adresseVisuelPetitFormat: string;
  libelleArticle: string;
  idArticle: string;
  codeEAN: string;
  dateDisponibilite: string;
  articlesOfferts: Array<any>;

}



// WEBPACK FOOTER //
// ./src/app/shared/models/ligne-panier.model.ts